import { render, staticRenderFns } from "./DotLoader.vue?vue&type=template&id=1008cb30&scoped=true"
import script from "./DotLoader.vue?vue&type=script&lang=js"
export * from "./DotLoader.vue?vue&type=script&lang=js"
import style0 from "./DotLoader.vue?vue&type=style&index=0&id=1008cb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008cb30",
  null
  
)

export default component.exports